import { Text } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

export default function Title({ text }: { text: string }) {
  const tailwind = useTailwind();
  return (
    <Text variant="titleLarge" style={tailwind("font-bold")}>
      {text}
    </Text>
  );
}
